/* eslint-disable const-case/uppercase */
import { ErrorCode, ErrorType } from "../applicationError"
import { Response } from "../Model"
import client from "./client"

export interface ActiveData {
    BranchCode: string
    Checkclist: boolean
    ExchangeId: string
    PaymentArrearMonths: number
    PaymentTypeCode: number
    PaymentTypeName: string
    UnionCode: string
    isnebo: boolean
}

const getMembershipActiveData = (last4Nric: string, dob: string) => client
    .get<Response<ActiveData[]>>(`membership/check/active` + `/` + last4Nric + `/` + dob)
    .then(response => response.data.content)

interface EligibilityParams {
    occupationGroupCode: string
    companyCode: string
    jobTitle: string
}
interface EligibilityData {
    CheckIneligibleJobFlag: boolean
    Checkblist: boolean
    Checkclist: boolean
    Checkelig: boolean
    Eligibility: string
    IneligibleMessage: string
    ShowActiveMessage: string
    ShowBlacklistMessage: string
}

const getMembershipEligibilityData = (nric: string, eligibilityParams?: EligibilityParams) => {
    return client
        .get<Response<EligibilityData[]>>(
        `membership/check/eligibility` + `/` + nric,
        {
            params: eligibilityParams,
        })
        .then(response => {
            if (response.data.content.length > 0) {
                const eligibility = response.data.content[0]
                if (eligibility.Checkblist) { // Eligibility based on blacklist
                    const error = {
                        error: ErrorType.JobTitleInEligible,
                        errorDescription: eligibility.Eligibility,
                        errorCode: ErrorCode.CANNOT_PROCEED,
                    }
                    return Promise.reject(error)
                } else if (eligibility.CheckIneligibleJobFlag || eligibility.Checkelig) { // Eligibility based on occupation group & job.
                    const error = {
                        error: ErrorType.JobTitleInEligible,
                        errorDescription: eligibility.IneligibleMessage,
                        errorCode: ErrorCode.UNKNOWN_ERROR,
                    }
                    return Promise.reject(error)
                } else if (eligibility.Checkclist) { // Eligibility based on membership active in UCEM
                    const error = {
                        error: ``,
                        errorDescription: ``,
                        errorCode: ErrorCode.RECORD_EXISTS_ACTIVE,
                    }
                    return Promise.reject(error)
                }
            }
            return response.data.content
        })
}

export type {EligibilityParams, EligibilityData }
export { getMembershipActiveData, getMembershipEligibilityData }